import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { VoucherForm } from "../VoucherForm";
import { CreateVoucherModalProps } from "./types";
import { useCreateVoucherModal } from "./controller";

export const CreateVoucherModal = React.memo(({ modalRef, onComplete }: CreateVoucherModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateVoucherModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("voucher_batch_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <VoucherForm />
    </Modal>
  );
});
